import { all, call, takeEvery, put } from "redux-saga/effects";

import { COMPANY_RECENT_ACTIVITY_LIST } from "./actionType";

import {
  companyRecentActivityListSuccess,
  companyRecentActivityListFailure,
} from "./action";

import { companyRecentActivityListApi } from "../../helpers/fakebackend_helper";

// get company recent activity list
function* companyRecentActivityList() {
  try {
    const response = yield call(companyRecentActivityListApi);
    yield put(companyRecentActivityListSuccess(response));
  } catch (error) {
    yield put(companyRecentActivityListFailure(error));
  }
}

export function* watchCompanyRecentActivityList() {
  yield takeEvery(COMPANY_RECENT_ACTIVITY_LIST, companyRecentActivityList);
}

export default function* CompanyRecentActivity() {
  yield all([watchCompanyRecentActivityList()]);
}
